import axios from "axios";
import { getQueryString } from "../utils/function";
import moment from "moment";
const devEnv = process.env.NODE_ENV !== "production";

const API = axios.create({
  baseURL: `${
    devEnv ? process.env.REACT_APP_DEV_API : process.env.REACT_APP_PROD_API
  }`,
  withCredentials: true,
});

API.interceptors.request.use((req) => {
  if (localStorage.getItem("accessToken")) {
    req.headers.Authorization = `Bearer ${localStorage.getItem("accessToken")}`;
  }
  return req;
});
// Authors
export const signUp = (formData) =>
  API.post("/auth/send-verification-code", formData);
export const signIn = (formData) => API.post("/auth/login", formData);
export const logout = () => API.post("/auth/logout");
export const changePassword = (data) =>
  API.post("/admin/change-password", data);
export const alertNotification = (data) =>
  API.post("/admin/send-alert-notification", data);
export const editAlertNotification = (data) =>
  API.patch("/admin/edit-alert-notification", data);
export const changeEmail = (data) => API.patch("/admin", data);
export const togglePaymentGateway = (id, data) =>
  API.patch(`/portal-configuration/${id}`, data);

export const getAdmin = () => API.get("/admin");

export const getFileUrl = (data) => API.post("/upload", data);

export const activateMerchnat = (id) =>
  API.put(`/admin/accept-merchant-registration/${id}`);

export const changeMerchantStatus = (id, path) =>
  API.put(`/admin/${path}/${id}`);
export const deActivateMerchant = (id) =>
  API.put(`/admin/reject-merchant-registration/${id}`);
export const blockUnblockMerchant = (id) =>
  API.put(`/admin/block-unblock-merchant/${id}`);
export const acceptUserKYCRequest = (id) =>
  API.put(`admin/accept-merchant-kyc/${id}`);
export const rejectMerchantKYCRequest = (id) =>
  API.put(`admin/reject-merchant-kyc/${id}`);
export const updateMerchnatDetails = (id, form) =>
  API.put(`admin/update-merchant/${id}`, form);

// Social post api
export const addSocial = (form) => API.post("/admin/social-id", form);
export const getSocial = (form) => API.post("/admin/get-social-id", form);

export const getPartnersList = (latitude, longitude) =>
  API.get(
    `/admin/all/partner-list?${`latitude=${latitude}`}&longitude=${longitude}`,
  );

export const addtoPartner = (form) => API.post("/admin/partner-assign", form);

// New Admin API's
export const addtoBuyer = (form) =>
  API.post("/purchase/create-buy-request", form);
export const getSingleFactionAmount = () =>
  API.post("/purchase/node-fraction-price");
export const getStages = () => API.get("/purchase/all/stages");

export const getProfitFromDownline = () =>
  API.get("admin/me/profit-from-downline");
export const getSingleStage = (id) => API.get(`/purchase/stage/${id}`);

// export const getSingleFraction = (
//   page = 0,
//   id,
//   searchText,
//   startDate,
//   endDate
// ) => {
//   let url = `/purchase/stage-fractions/${id}?skip=${page * 8}&take=8`;
//   if (searchText && searchText.trim() !== "") {
//     url += `&search=${searchText}`;
//   }
//   if (startDate && endDate) {
//     url += `&startDate=${moment(startDate).startOf("day").toISOString()}`;
//     url += `&endDate=${moment(endDate).endOf("day").toISOString()}`;
//   }
//   return API.get(url);
// };

export const getSingleFraction = (
  page = 0,
  pageSize,
  searchText,
  startDate,
  endDate,
) => {
  let url = `/fractions/list?skip=${page * pageSize}&take=${pageSize}`;
  if (searchText && searchText.trim() !== "") {
    url += `&search=${searchText}`;
  }
  if (startDate && endDate) {
    url += `&startDate=${moment(startDate).startOf("day").toISOString()}`;
    url += `&endDate=${moment(endDate).endOf("day").toISOString()}`;
  }
  return API.get(url);
};
// export const getSingleFraction = (
//   page = 0,
//   id,
//   searchText,
//   startDate,
//   endDate
// ) =>
//   API.get(
//     `/purchase/stage-fractions/${id}?skip=${page * 8}&take=8${
//       searchText === "" ? "" : `&search=${searchText}`
//     }`
//   );
// export const getUsers = (
//   page = 0,
//   search,
//   queryParams,
//   userType,
//   startDate,
//   endDate
// ) => {
//   const urlParams = new URLSearchParams();

//   if (search != "") {
//     urlParams.append("search", search);
//   }

//   if (queryParams) {
//     Object.keys(queryParams).forEach((key) => {
//       urlParams.append(key, queryParams[key]);
//     });
//   }
//   const query = getQueryString({
//     skip: page * 8,
//     take: 8,
//     isPurchased: userType === "Paid" ? true : userType === "Unpaid" ? false : ""
//   });

//   if (startDate && endDate) {
//     queryObj.startDate = moment(startDate).startOf("day").toISOString();
//     queryObj.endDate = moment(endDate).endOf("day").toISOString();
//   }
//   const url = `/users?${query}&${urlParams.toString()}`;

//   return API.get(url);
// };

export const getUsers = (
  page = 0,
  search,
  queryParams,
  userType,
  startDate,
  endDate,
) => {
  const urlParams = new URLSearchParams();
  if (search !== "") {
    urlParams.append("search", search);
  }
  if (queryParams) {
    Object.keys(queryParams).forEach((key) => {
      urlParams.append(key, queryParams[key]);
    });
  }
  const queryObj = {
    skip: page * 8,
    take: 8,
    isPurchased:
      userType === "Paid" ? true : userType === "Unpaid" ? false : "",
  };
  if (startDate && endDate) {
    queryObj.startDate = moment(startDate).startOf("day").toISOString();
    queryObj.endDate = moment(endDate).endOf("day").toISOString();
  }
  const query = getQueryString(queryObj);
  const url = `/users?${query}&${urlParams.toString()}`;

  return API.get(url);
};

export const getAlertNotification = () => {
  return API.get("/admin/alert-notification");
};

// Add Sub admin API's
export const addSubAdmin = (form) => API.post("/sub-admin/register", form);

export const getSubAdmins = (page = 0, search) =>
  API.get(
    `/sub-admin?skip=${page * 8}&take=8${
      search === "" ? "" : `&search=${search}`
    }`,
  );

export const getGatewayConfig = () => API.get(`/portal-configuration`);

// Add for get purchase API's
export const getPurchase = (
  page = 0,
  startDate,
  endDate,
  status,
  searchText,
) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    status: status,
    search: searchText,
  });
  return API.get(`/admin/me/manual-purchase-request?${query}`);
};

// Add for get purchase API's
export const getWRequest = (page = 0, startDate, endDate, status) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    status: status,
  });
  return API.get(`/admin/user/manual-payout-request?${query}`);
};

// Accept purchase request API's
export const acceptPurchaseReq = (data) => {
  const query = getQueryString({
    purchaseId: data.purchaseId,
    amount: data.amount,
    razorpayPaymentId: data.razorpayPaymentId,
    realPaymentId: data?.realPaymentId,
  });
  return API.post(`/admin/me/accept-purchase-request?${query}`);
};
// export const acceptPurchaseReq = (id) => {
//   const query = getQueryString({
//     purchaseId: id,
//   });
//   return API.post(`/admin/me/accept-purchase-request?${query}`);
// };

// Reject purchase request API's
export const rejectPurchaseReq = (form) => {
  const query = getQueryString({
    purchaseId: form.purchaseId,
    reason: form.reason,
  });
  return API.post(`/admin/me/reject-purchase-request?${query}`);
};

// Add for get purchase API's
// export const getSales = (page = 0, startDate, endDate, status) => {
export const getSales = (page = 0, search, startDate, endDate) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    search: search,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
  });
  return API.post(`/purchase/get-success-payments?${query}`);
};

export const getClubReport = (
  page = 0,
  search,
  startDate,
  endDate,
  clubLevel,
) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    search: search,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    clubLevel: clubLevel,
  });
  return API.get(`/automate-commission/club-member-monthly-stat?${query}`);
};
//getEligibleSales
export const getEligibleSales = (page = 0, search) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    search: search,
  });
  return API.get(`/reports/affiliate-sales/eligible?${query}`);
};

//getInEligibleSales
export const getInEligibleSales = (page = 0, search, type) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    search: search,
  });
  return API.get(`/reports/affiliate-sales/ineligible?${query}`);
};

export const getMyCommission = (page = 0, search, userId) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    search: search,
    beneficiaryUserId: userId,
  });
  return API.get(`/reports/commission?${query}`);
};

export const getHierarchyCommission = (page = 0, search, userId) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    search: search,
    initiatorUserId: userId,
  });
  return API.get(`/reports/commission?${query}`);
};
// change user password
export const changeUserPassword = (form) =>
  API.patch("/admin/change-user-password", form);

//Accept Mannual Request
export const acceptMannualWRequest = (form) =>
  API.patch("/admin/user/accept-manual-payout-request", form);

// Reject All Mannual Request
export const rejectAllMannualWRequest = () =>
  API.patch("/admin/user/reject-all-payout-request");

// block user
export const blockUserAndSuspendById = (id, blockLabel) =>
  API.patch(
    `/admin/user-status?userId=${id}&status=${
      blockLabel === "Unblock"
        ? "Active"
        : blockLabel === "Reinstate"
          ? "Active"
          : blockLabel === "Block"
            ? "Blocked"
            : blockLabel
    }`,
  );

export const NotificationPublishedUnpublish = (alertNotificationId) =>
  API.patch(
    `/admin/publish-unpublish-notification?alertNotificationId=${alertNotificationId}`,
  );

export const DeleteNotification = (alertNotificationId) =>
  API.delete(
    `/admin/delete-alert-notification?alertNotificationId=${alertNotificationId}`,
  );

export const DeleteUser = (userId) =>
  API.delete(`/admin/delete-user?userId=${userId}`);

// suspend user user
export const suspendUserById = (form) =>
  API.post("/admin/user-suspend-by-admin", form);

// block Sub admin
export const blockSubAdminById = (id, blockLabel) =>
  API.patch(
    `/admin/subadmin-status?userId=${id}&status=${
      blockLabel === "Unblock" ? "Active" : "Block"
    }`,
  );

// change Sub admin password
export const changeSubAdminPassword = (form) =>
  API.patch("/admin/change-subadmin-password", form);

// Block Report
export const getReportList = (page = 0, startDate, endDate, typeOfNodeId) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    nodeId: typeOfNodeId,
  });
  return API.get(`/reports/all?${query}`);
};

// GST Report
export const getGstReports = (
  page = 0,
  startDate,
  endDate,
  settlement,
  gstType,
  state,
  search = "",
) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    gstSettlementStatus: settlement,
    gstType: gstType,
    state: state,
    search: search,
  });
  return API.get(`/reports/gst?${query}`);
};

// Update GST Report
export const updateGstReports = (id) => {
  const query = getQueryString({
    paymentId: id,
  });
  return API.patch(`/admin/me/gst-pay-status?${query}`);
};

// Export GST Report page = 0,
export const exportGstReports = (
  startDate,
  endDate,
  settlement,
  gstType,
  state,
  search = "",
) => {
  const query = getQueryString({
    // skip: page * 8,
    // take: 8,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    gstSettlementStatus: settlement,
    gstType: gstType,
    state: state,
    search: search,
  });
  return API.get(`/reports/gst-csv?${query}`);
};

// Export withdraw request Report ,
export const exportWithdrawRequest = (startDate, endDate, status) => {
  const query = getQueryString({
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    status: status,
  });
  return API.get(`/admin/user/payouts-csv?${query}`);
};

// Export withdraw request Report ,
export const exportDailySalesCsv = (startDate, endDate) => {
  const query = getQueryString({
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
  });
  return API.get(`/purchase/get-success-payments-csv?${query}`);
};

export const exportClubReportCsv = (startDate, endDate, search, clubLevel) => {
  const query = getQueryString({
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    search: search,
    clubLevel: clubLevel,
  });
  return API.get(`/automate-commission/club-member-monthly-stat-csv?${query}`);
};

// TDS Report
export const getTdsReports = (
  page = 0,
  startDate,
  endDate,
  search,
  typeOfFilter,
) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    fromDate: moment(startDate).startOf("day").toISOString(),
    toDate: moment(endDate).endOf("day").toISOString(),
    search: search,
    aggregate: typeOfFilter === "pan" ? true : false,
  });
  return API.get(`/referrals/tdsReport?${query}`);
};

// TDS Report
export const getCommissionReports = (page = 0, startDate, endDate, search) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    search: search,
  });
  return API.get(`/reports/commission?${query}`);
};

// Export TDS Report  page = 0,
export const exportTdsReports = (startDate, endDate, search, typeOfFilter) => {
  const query = getQueryString({
    // skip: page * 8,
    // take: 8,
    fromDate: moment(startDate).startOf("day").toISOString(),
    toDate: moment(endDate).endOf("day").toISOString(),
    search: search,
    aggregate: typeOfFilter === "pan" ? true : false,
  });
  return API.get(`/referrals/tdsExcelReport?${query}`);
};

// Export TDS Report  page = 0,
export const exportCommissionReports = (startDate, endDate, search) => {
  const query = getQueryString({
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),

    search: search,
  });
  return API.get(`/reports/commission-csv?${query}`);
};

export const getReportListDetails = (nodeId, date, page = 0) => {
  const query = getQueryString({
    nodeId: nodeId,
    skip: page * 8,
    take: 8,
    date: date,
  });
  return API.get(`/reports/date?${query}`);
};

export const getReportDashboard = () => API.get("/reports/dashboard");

export const getFractiontList = () => API.get("/reports/validated-fractions");

// export const getFranchise = (
//   page = 0,
//   selectedOption,
//   search,
//   level,
//   referredAs,
//   startDate,
//   endDate
// ) => {
//   const query = getQueryString({
//     skip: page * selectedOption,
//     take: selectedOption,
//     search: search,
//     level: level,
//     referredAs: referredAs,
//     startDate: moment(startDate).startOf("day").toISOString(),
//     endDate: moment(endDate).endOf("day").toISOString()
//   });
//   return API.get(`/admin/me/hierarchy?${query}`);
// };

export const getFranchise = (
  // page = 0,
  selectedOption,
  search,
  level,
  referredAs,
  startDate,
  endDate,
  nextCursor,
  prevCursor,
  direction,
  selectPercent,
) => {
  const queryObj = {
    // skip: page * selectedOption,
    take: selectedOption,
    search,
    level,
    referredAs,
    cursor: direction == "next" ? nextCursor : prevCursor,
    direction: direction,
    commissionPercentage: selectPercent,
  };
  if (startDate && endDate) {
    queryObj.startDate = moment(startDate).startOf("day").toISOString();
    queryObj.endDate = moment(endDate).endOf("day").toISOString();
  }
  if (!direction) {
    delete queryObj.cursor;
    delete queryObj.direction;
  }
  // if (search || search || level || referredAs) {
  //   delete queryObj.cursor;
  //   delete queryObj.direction;
  // }
  const query = getQueryString(queryObj);
  return API.get(`/admin/me/hierarchy?${query}`);
};
export const getDownLineUserCount = (userId, startDate, endDate) => {
  const queryObj = {
    userId: userId,
  };
  if (startDate && endDate) {
    queryObj.startDate = moment(startDate).startOf("day").toISOString();
    queryObj.endDate = moment(endDate).endOf("day").toISOString();
  }
  const query = getQueryString(queryObj);
  return API.get(`/referrals/total-downline-count?${query}`);
};

export const getForFranchiseDropDown = (page = 0, type) => {
  const query = getQueryString({
    skip: page * 10000,
    take: 10000,
    referredAs: type,
  });
  return API.get(`/admin/me/hierarchy?${query}`);
};

export const getForFranchise = (page = 0) => {
  const query = getQueryString({
    skip: page * 10000,
    take: 10000,
  });
  return API.get(`/admin/me/hierarchy?${query}`);
};

export const getFranchiseCsv = (
  // page = 0,
  // selectedOption,
  search,
  level,
  referredAs,
) => {
  const query = getQueryString({
    // skip: page * selectedOption,
    // take: selectedOption,
    search: search,
    level: level,
    referredAs: referredAs,
  });
  return API.get(`/admin/me/hierarchy/csv?${query}`);
};
// register user
export const registerUser = (form) => API.post("/auth/register", form);

// update user
export const updateUser = (form) => API.patch("/admin/user-detail", form);

// genarate jwt token as a user
export const generateJwt = (form) => API.post("/auth/generate-jwt-token", form);

// Add Franshise to user
export const addFranchiseToUser = (form) =>
  API.post("/admin/assign/hierarchy", form);

// Remove Franshise
export const removeFranchise = (form) =>
  API.post("/admin/close-user-franchise", form);

// Remove Power Franshise
export const removePowerFranchise = (form) =>
  API.post("/admin/close-user-power-franchise", form);

// Add for get gas fee request API's
export const getGasFeeRequest = (page = 0, startDate, endDate, status) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    status: status,
  });
  return API.get(`/admin/me/user-gas-fees-request?${query}`);
};

// Accept Withdraw request API's
export const acceptWithdrawReq = (id) => {
  const payload = {
    gasFeesId: id,
  };
  return API.patch(`/admin/me/accept-gas-fees-request`, payload);
};

// Reject Withdraw request API's
export const rejectWithdrawReq = (form) => {
  const payload = {
    gasFeesId: form.gasFeesId,
    reason: form.reason,
  };
  return API.patch(`/admin/me/reject-gas-fees-request`, payload);
};

// Add for get withdraw Reward request API's
export const getWithdrawRewardRequest = (
  page = 0,
  startDate,
  endDate,
  nodeId,
  walletAddress,
  // walletAddress
) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    nodeId: nodeId,
    walletAddress: walletAddress,
    // walletAddress: walletAddress
  });
  return API.get(`/admin/user/reward-withdraw-history?${query}`);
};

// Cash Payout
export const cashPayout = (form) => API.post("/admin/user/cash-payout", form);

// Get Payout Transactions
export const getPayoutTransactions = (
  page = 0,
  pageSize,
  startDate,
  endDate,
  search,
  mode,
  status,
) => {
  const query = getQueryString({
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    skip: page * pageSize,
    take: pageSize,
    search: search,
    type: mode,
    status: status,
  });
  return API.get(`/admin/user/payouts?${query}`);
};

// Get Withdraw Request
export const getWithdrawRequest = (page = 0, startDate, endDate, search) => {
  const query = getQueryString({
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    skip: page * 8,
    take: 8,
    search: search,
  });
  return API.get(`/admin/user/payout-request?${query}`);
};

// Wallet Update request API's
export const getWalletUpdateRequest = (
  page = 0,
  startDate,
  endDate,
  status,
) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    status: status,
  });
  return API.get(`/admin/user/wallet-change-request?${query}`);
};

// Reject wallet update request API's
export const rejectWalletUpdateReq = (form) => {
  return API.patch(`/admin/user/reject-wallet-change-request`, form);
};

//  API's
export const failedSuccessReq = (form) => {
  return API.patch(`/admin/user/payout-status`, form);
};
// Accept Waller request API's
export const acceptWalletUpdateReq = (id) => {
  const payload = {
    requestId: id,
  };
  return API.patch(`/admin/user/accept-wallet-change-request`, payload);
};

// wallet address request API's
export const getWalletAddressLogs = (
  page = 0,
  startDate,
  endDate,
  search = "",
) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    search: search,
  });
  return API.get(`/admin/user/wallet-history-log?${query}`);
};

// email update request API's
export const getEmailUpdateLogs = (page = 0, startDate, endDate, type) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    type: type,
  });
  return API.get(`/admin/user/email-update-log?${query}`);
};

// export const getActivityLogs = (page = 0) => {
//   const query = getQueryString({
//     skip: page * 8,
//     take: 8
//   });
//   return API.get(`/admin/action-logs?${query}`);
// };

export const getActivityLogs = (page = 0, startDate, endDate) => {
  const queryObj = {
    skip: page * 8,
    take: 8,
  };
  if (startDate && endDate) {
    queryObj.startDate = moment(startDate).startOf("day").toISOString();
    queryObj.endDate = moment(endDate).endOf("day").toISOString();
  }
  const query = getQueryString(queryObj);
  return API.get(`/admin/action-logs?${query}`);
};

// export const getPayoutLogs = (page = 0) => {
//   const query = getQueryString({
//     skip: page * 8,
//     take: 8
//   });
//   return API.get(`/admin/payout-action-logs?${query}`);
// };

export const getPayoutLogs = (page = 0, startDate, endDate) => {
  const queryObj = {
    skip: page * 8,
    take: 8,
  };
  if (startDate && endDate) {
    queryObj.startDate = moment(startDate).startOf("day").toISOString();
    queryObj.endDate = moment(endDate).endOf("day").toISOString();
  }
  const query = getQueryString(queryObj);
  return API.get(`/admin/payout-action-logs?${query}`);
};

// export const getPurchaseLogs = (page = 0) => {
//   const query = getQueryString({
//     skip: page * 8,
//     take: 8
//   });
//   return API.get(`/admin/purchase-action-logs?${query}`);
// };

export const getPurchaseLogs = (page = 0, startDate, endDate) => {
  const queryObj = {
    skip: page * 8,
    take: 8,
  };
  if (startDate && endDate) {
    queryObj.startDate = moment(startDate).startOf("day").toISOString();
    queryObj.endDate = moment(endDate).endOf("day").toISOString();
  }
  const query = getQueryString(queryObj);
  return API.get(`/admin/purchase-action-logs?${query}`);
};

// for get payout request
export const getPayoutRequest = (
  page = 0,
  startDate,
  endDate,
  status,
  search,
) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
    startDate: moment(startDate).startOf("day").toISOString(),
    endDate: moment(endDate).endOf("day").toISOString(),
    status: status,
    search: search,
  });
  return API.get(`/admin/user/payout-request?${query}`);
};

// Accept payout request API's
export const acceptPayoutReq = (id) => {
  return API.patch(`/admin/user-payout/accept/${id}`);
};
// Reject payout request API's
export const rejectPayoutReq = (form) => {
  const payload = {
    reason: form.reason,
  };
  return API.patch(`/admin/user-payout/reject/${form.payoutID}`, payload);
};

// Reject mannual withdraw request API's
export const rejectMannualWReq = (form) => {
  return API.patch("/admin/user/reject-manual-payout-request", form);
};

export const addQr = (form) => API.post("/payment-qr", form);

export const deleteQr = (qrId) => API.delete(`/payment-qr/${qrId}`);

export const getQRImages = (page = 0) => {
  const query = getQueryString({
    skip: page * 8,
    take: 8,
  });
  const url = `/payment-qr/all/admin?${query}`;
  return API.get(url);
};

export const qrStatusChange = (id, status) => {
  const payload = {
    isActive: status,
  };
  return API.patch(`/payment-qr/${id}`, payload);
};

export const paymentSettleChange = (id) => {
  return API.patch(`/automate-commission/settle-club-profit/${id}`);
};

// partners
export const getPartners = (page = 1, limit = 8, search = "") => {
  const query = getQueryString({
    page,
    limit,
    search,
  });

  return API.get(`/partners?${query}`);
};

export const deletePartner = (partnerId) =>
  API.delete(`/partners/${partnerId}`);

export const addPartner = (formData) => API.post("/partners/create", formData);

export const updatePartner = (partnerId, formData) =>
  API.patch(`/partners/${partnerId}`, formData);

export const publishPartner = (id) =>
  API.patch(`/partners/${id}/publish`);

export const unpublishPartner = (id) =>
  API.patch(`/partners/${id}/unpublish`);

// categories-partner---
export const getAllCategories = () =>
  API.get("/partners/category/all");

export const createCategory = (data) =>
  API.post("/partners/category", data);

export const deleteCategory = (categoryId) =>
  API.delete(`/partners/category/${categoryId}`);

export const updateCategoryPriority = (categoryName, data) =>
  API.patch(`/partners/category/${categoryName}`, data);
